import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Card,
  Grid,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
} from "@mui/material";
import MDBox from "components/MDBox";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { getDisputes } from "store/slice/disputes/disputeSlice";
import DisputesTable from "./components/DisputesTable";

const Disputes = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const { disputesList, meta, loading } = useSelector(
    (state) => state.disputes
  );

  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getDisputes({
        startDate,
        endDate,
        search,
        page: page + 1,
        limit: pageSize,
      })
    );
  }, [dispatch, startDate, endDate, page, pageSize, search]);

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={2} pb={3}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={1}
                  mt={-2}
                  py={1}
                  px={1}
                  variant="gradient"
                  bgColor={sidenavColor}
                  borderRadius="lg"
                  coloredShadow={sidenavColor}
                  className="d-flex align-items-center justify-content-between"
                >
                  <MDTypography variant="h6" color="white">
                    Disputes
                  </MDTypography>
                </MDBox>
                {/* Filter controls */}
                <MDBox my={3} px={2}>
                  <Grid container justifyContent="flex-end" spacing={2}>
                    {/* <Grid item xs={12} sm="auto">
                      <TextField
                        size="small"
                        label="Start Date"
                        type="date"
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        value={startDate}
                        onChange={(e) => {
                          setStartDate(e.target.value);
                          setPage(0);
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} sm="auto">
                      <TextField
                        size="small"
                        label="End Date"
                        type="date"
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        value={endDate}
                        onChange={(e) => {
                          setEndDate(e.target.value);
                          setPage(0);
                        }}
                      />
                    </Grid> */}

                    <Grid item xs={12} sm={4}>
                      <TextField
                        size="small"
                        label="Search"
                        variant="outlined"
                        fullWidth
                        value={searchInput}
                        onChange={(e) => setSearchInput(e.target.value)}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {searchInput && (
                                <IconButton
                                  aria-label="clear search"
                                  edge="end"
                                  onClick={() => {
                                    setSearchInput("");
                                    setSearch("");
                                    setPage(0);
                                  }}
                                >
                                  <ClearIcon />
                                </IconButton>
                              )}
                              <IconButton
                                edge="end"
                                onClick={() => {
                                  setSearch(searchInput.trim());
                                  setPage(0);
                                }}
                              >
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                  </Grid>
                </MDBox>

                <MDBox>
                  <DisputesTable
                    disputesList={disputesList}
                    totalDisputes={meta.total}
                    loading={loading}
                    page={page}
                    pageSize={pageSize}
                    startDate={startDate}
                    endDate={endDate}
                    onPageChange={setPage}
                    onPageSizeChange={setPageSize}
                  />
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        <Footer />
      </DashboardLayout>
    </>
  );
};

export default Disputes;
